var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "lead-in-vue" } }, [
      _c("h1", [
        _vm._v("Jordan Foreman "),
        _c("span", [_vm._v("&")]),
        _vm._v(" Maggi Vodraska")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("...invite you to share in our special day!")]),
      _vm._v(" "),
      _c("h3", [_vm._v("When")]),
      _vm._v(" "),
      _c("p", [_vm._v("September 8, 2018")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23c9ad0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c9ad0c","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/views/lead-in.vue
// module id = 63
// module chunks = 0